var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    { attrs: { flat: "" } },
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            [
              _c(
                "v-radio-group",
                {
                  attrs: {
                    row: "",
                    rules: [_vm.rules.required()],
                    label: "El movimiento de equipos será "
                  },
                  model: {
                    value: _vm.transferInformation.movementType.id,
                    callback: function($$v) {
                      _vm.$set(_vm.transferInformation.movementType, "id", $$v)
                    },
                    expression: "transferInformation.movementType.id"
                  }
                },
                _vm._l(_vm.formValues.movementTypes, function(type) {
                  return _c(
                    "div",
                    { key: type.value },
                    [
                      _c("v-radio", {
                        attrs: {
                          color: "#60BB46",
                          label: type.text,
                          value: type.value
                        }
                      })
                    ],
                    1
                  )
                }),
                0
              )
            ],
            1
          )
        ],
        1
      ),
      _vm.isEntry
        ? [
            _c(
              "v-row",
              { staticClass: "mr-2 ml-2" },
              [
                _c(
                  "v-col",
                  { attrs: { cols: "12", sm: "6" } },
                  [
                    _c("v-text-field", {
                      attrs: {
                        label: "Modelo",
                        rules: [
                          _vm.rules.required(),
                          _vm.rules.fieldLength(20),
                          _vm.rules.specialCharacters()
                        ]
                      },
                      model: {
                        value: _vm.hardware.model,
                        callback: function($$v) {
                          _vm.$set(_vm.hardware, "model", $$v)
                        },
                        expression: "hardware.model"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "v-col",
                  { attrs: { cols: "12", sm: "6" } },
                  [
                    _c("v-text-field", {
                      attrs: {
                        label: "Número serial",
                        rules: [
                          _vm.rules.required(),
                          _vm.rules.fieldLength(20),
                          _vm.rules.specialCharacters()
                        ]
                      },
                      model: {
                        value: _vm.hardware.serialNumber,
                        callback: function($$v) {
                          _vm.$set(_vm.hardware, "serialNumber", $$v)
                        },
                        expression: "hardware.serialNumber"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "v-row",
              { staticClass: "mr-2 ml-2" },
              [
                _c(
                  "v-col",
                  { attrs: { cols: "12", sm: "6" } },
                  [
                    _c("v-text-field", {
                      attrs: {
                        label: "Voltaje nominal",
                        suffix: "V",
                        rules: [_vm.rules.allowedDecimals()]
                      },
                      model: {
                        value: _vm.hardware.nominalVoltage,
                        callback: function($$v) {
                          _vm.$set(_vm.hardware, "nominalVoltage", $$v)
                        },
                        expression: "hardware.nominalVoltage"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "v-col",
                  { attrs: { cols: "12", sm: "6" } },
                  [
                    _c("v-text-field", {
                      attrs: {
                        label: "Consumo nominal",
                        suffix: "W",
                        rules: [_vm.rules.allowedDecimals()]
                      },
                      model: {
                        value: _vm.hardware.nominalConsumption,
                        callback: function($$v) {
                          _vm.$set(_vm.hardware, "nominalConsumption", $$v)
                        },
                        expression: "hardware.nominalConsumption"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]
        : _vm._e(),
      _vm.isExit
        ? [
            _c(
              "v-row",
              [
                _c(
                  "v-col",
                  [
                    _c("v-autocomplete", {
                      attrs: {
                        rules: [_vm.rules.required()],
                        items: _vm.formValues.accessEquipmentDepartureTypes,
                        "item-text": "name",
                        "return-object": "",
                        label: "Concepto de salida del equipo",
                        placeholder:
                          "Selecciona la razon de la salida del (de los) equipo(s) del Centro de Datos"
                      },
                      model: {
                        value: _vm.transferInformation.reasonForTransfer,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.transferInformation,
                            "reasonForTransfer",
                            $$v
                          )
                        },
                        expression: "transferInformation.reasonForTransfer"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _vm.formValues != {}
              ? _c(
                  "div",
                  [
                    _c(
                      "v-row",
                      [
                        _c(
                          "v-col",
                          [
                            _c(
                              "v-radio-group",
                              {
                                attrs: {
                                  row: "",
                                  rules: [_vm.rules.required()],
                                  label:
                                    "¿De cuánto será la duración de la salida del (de los) equipo(s)?"
                                },
                                model: {
                                  value:
                                    _vm.transferInformation.lengthOfTransfer,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.transferInformation,
                                      "lengthOfTransfer",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "transferInformation.lengthOfTransfer"
                                }
                              },
                              _vm._l(
                                _vm.formValues
                                  .accessEquipmentDeparturePeriodTypes,
                                function(type) {
                                  return _c(
                                    "div",
                                    { key: type.value },
                                    [
                                      _c("v-radio", {
                                        attrs: {
                                          color: "#60BB46",
                                          label: type.text,
                                          value: type.value
                                        }
                                      })
                                    ],
                                    1
                                  )
                                }
                              ),
                              0
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "v-row",
              [
                _c(
                  "v-col",
                  [
                    _c("v-text-field", {
                      attrs: {
                        label: "Destino del (de los) equipo(s)",
                        rules: [
                          _vm.rules.specialCharacters(),
                          _vm.rules.fieldLength(20)
                        ]
                      },
                      model: {
                        value: _vm.transferInformation.destination,
                        callback: function($$v) {
                          _vm.$set(_vm.transferInformation, "destination", $$v)
                        },
                        expression: "transferInformation.destination"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "v-col",
                  [
                    _c("v-text-field", {
                      attrs: {
                        label: "Motivo de la salida del (de los) equipo(s)",
                        rules: [
                          _vm.rules.specialCharacters(),
                          _vm.rules.fieldLength(20)
                        ]
                      },
                      model: {
                        value: _vm.transferInformation.motive,
                        callback: function($$v) {
                          _vm.$set(_vm.transferInformation, "motive", $$v)
                        },
                        expression: "transferInformation.motive"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "v-row",
              { staticClass: "mr-2 ml-2" },
              [
                _c(
                  "v-col",
                  { attrs: { cols: "12", sm: "4" } },
                  [
                    _c("v-text-field", {
                      attrs: {
                        label: "Nombre",
                        placeholder: "",
                        rules: [
                          _vm.rules.fieldLength(20),
                          _vm.rules.specialCharacters()
                        ]
                      },
                      model: {
                        value: _vm.hardware.name,
                        callback: function($$v) {
                          _vm.$set(_vm.hardware, "name", $$v)
                        },
                        expression: "hardware.name"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "v-col",
                  { attrs: { cols: "12", sm: "4" } },
                  [
                    _c("v-text-field", {
                      attrs: {
                        label: "Modelo",
                        rules: [
                          _vm.rules.fieldLength(20),
                          _vm.rules.specialCharacters()
                        ]
                      },
                      model: {
                        value: _vm.hardware.model,
                        callback: function($$v) {
                          _vm.$set(_vm.hardware, "model", $$v)
                        },
                        expression: "hardware.model"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "v-col",
                  { attrs: { cols: "12", sm: "4" } },
                  [
                    _c("v-text-field", {
                      attrs: {
                        label: "Marca",
                        rules: [
                          _vm.rules.fieldLength(20),
                          _vm.rules.specialCharacters()
                        ]
                      },
                      model: {
                        value: _vm.hardware.brand,
                        callback: function($$v) {
                          _vm.$set(_vm.hardware, "brand", $$v)
                        },
                        expression: "hardware.brand"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "v-row",
              { staticClass: "mr-2 ml-2" },
              [
                _c(
                  "v-col",
                  { attrs: { cols: "12", sm: "4" } },
                  [
                    _c("v-text-field", {
                      attrs: {
                        label: "Número serial",
                        rules: [
                          _vm.rules.fieldLength(20),
                          _vm.rules.specialCharacters()
                        ]
                      },
                      model: {
                        value: _vm.hardware.serialNumber,
                        callback: function($$v) {
                          _vm.$set(_vm.hardware, "serialNumber", $$v)
                        },
                        expression: "hardware.serialNumber"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "v-col",
                  { attrs: { cols: "12", sm: "4" } },
                  [
                    _c("v-text-field", {
                      attrs: {
                        label: "Voltaje nominal",
                        suffix: "V",
                        rules: [_vm.rules.allowedDecimals()]
                      },
                      model: {
                        value: _vm.hardware.nominalVoltage,
                        callback: function($$v) {
                          _vm.$set(_vm.hardware, "nominalVoltage", $$v)
                        },
                        expression: "hardware.nominalVoltage"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "v-col",
                  { attrs: { cols: "12", sm: "4" } },
                  [
                    _c("v-text-field", {
                      attrs: {
                        label: "Consumo nominal",
                        suffix: "W",
                        rules: [_vm.rules.allowedDecimals()]
                      },
                      model: {
                        value: _vm.hardware.nominalConsumption,
                        callback: function($$v) {
                          _vm.$set(_vm.hardware, "nominalConsumption", $$v)
                        },
                        expression: "hardware.nominalConsumption"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }